import type {
  ApiTokenDTO,
  CreateApiTokenRequestDTO,
  CreateApiTokenResponseDTO,
  ListApiTokensResponseDTO,
} from '@shared/dto/apiTokens';

import { callApi, callApiJson } from '../api';

export async function createApiToken(
  data: CreateApiTokenRequestDTO,
): Promise<CreateApiTokenResponseDTO> {
  const result: CreateApiTokenResponseDTO = await callApiJson('/api-tokens/create', {
    method: 'POST',
    body: JSON.stringify(data),
  });

  return result;
}

export async function listApiTokens(): Promise<ApiTokenDTO[]> {
  const result: ListApiTokensResponseDTO = await callApiJson('/api-tokens');

  return result;
}

export async function revokeApiToken(tokenId: string): Promise<void> {
  await callApi('/api-tokens/revoke', {
    method: 'POST',
    body: JSON.stringify({ tokenId }),
  });
}
